<div id="profile" class="watermark">
  <div class="container-fluid px-lg-5">
    <div class="row">
      <div class="col-12">

        <h2 class="title">About IQAC</h2>

        <h4 class="mt-3 mb-3" style="color: var(--primary); font-weight:600;">
          Internal Quality Assurance Cell
        </h4>

        <p class="inner-lead">
          <strong>Internal Quality Assurance Cell (IQAC)</strong> is established on 20th May, 2021 with a vision to
          streamline the quality initiatives of the institution. Institution’s IQAC is vibrant and is constituted as per
          the norms of NAAC. It has representation from most of the departments and has an amalgam of senior and junior teachers.
        </p>

        <h5 class="mt-4" style="font-weight: 600;">The IQAC mainly focuses on:</h5>
        <ul class="inner-lead">
          <li>Realizing the Mission and Vision of the institution.</li>
          <li>Defining the POs Institutionalizing the quality policies.</li>
          <li>Documenting the quality assuring strategies.</li>
          <li>Continuous improvement in the strategies after thoroughly assessing the attainment.</li>
          <li>Redefining the new goals and observing the attainment level.</li>
        </ul>

        <h5 class="mt-4" style="font-weight: 600;">The objectives of IQAC are:</h5>
        <ul class="inner-lead">
          <li>To develop a system for conscious, consistent and catalytic action to improve the academic and administrative performance of the institution.</li>
          <li>To promote measures for institutional functioning towards quality enhancement through internalization of quality culture and institutionalization of best practices.</li>
        </ul>

        <p class="inner-lead">
          IQAC of the institute persistently strives from framing strategies to bring about an effective, cohesive and
          mutually beneficial networking between the members of the alumni, to improve the teaching-learning process
          through increased use of ICT, expanding the scope of the library, skill development courses, arranging for
          industrial visit/training of students, assisting in placements, providing information on latest happenings by
          organizing seminars, conferences, workshops, guest lectures in the institution, training program, career
          consultations (higher studies, developing communication and interpersonal skills of students for interviews).
        </p>

        <p class="inner-lead">
          IQAC encourages various committees/cells of the institute like NSS, and alumni association to organize
          awareness camps, extension and service-oriented activities. IQAC facilitates the creation of learner centric
          environment by adopting the required knowledge and technology for participatory teaching and learning process.
          IQAC maintains institutional database, also analyses feedback from various offline and online sources. IQAC
          periodically conducts academic and administrative audits and follow up procedures.
        </p>

      </div>
    </div>
  </div>
</div>
